import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Directive({
    selector: '[appDebounceClick]',
    standalone: false
})
export class DebounceClickDirective implements OnInit, OnDestroy {
  @Input()
  debounceTimer = 500;

  @Output()
  debouncedClick = new EventEmitter();

  private readonly clicks = new Subject();
  private subscription: Subscription;

  constructor() {}

  ngOnInit() {
    this.subscription = this.clicks
      .pipe(throttleTime(this.debounceTimer))
      .subscribe((e) => this.emitThrottledClick(e));
  }

  emitThrottledClick(e) {
    this.debouncedClick.emit(e);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener('click', ['$event'])
  clickEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }
}
